import { FilterMenuConfig } from '../../types/filter.type';

export const DURATION_FILTERS: FilterMenuConfig = {
  filters: [
    {
      type: 'range',
      unit: 'min',
    },
  ],
};

export const DURATION_FILTER_HTTP_PARAM_NAMES: Record<string, string> = {
  min: 'minDuration',
  max: 'maxDuration',
};

export const DURATION_FILTER_HTTP_VALUE_TRANSFORM = (value: string | number): string | number => {
  const numericValue: number = Number(value);
  return Number.isNaN(numericValue) ? value : numericValue * 60;
};
